<template>
  <div class="continer">
    <HeaderTop></HeaderTop>
    <CompanyTitle></CompanyTitle>
    <RouterList></RouterList>
    <Banner></Banner>
    <div class="content">
      <!-- 左边列表 -->
      <div class="tab-list">
        <ul>
          <li v-for="(item,index) in companyList" @click="onChange(item,index)" :class="{'active':showIndex == index}" :key="index"> 
            {{item.label}}
          </li>
        </ul>
      </div>
      <div class="right-content">
        <!-- 面包屑 -->
        <div class="navigation">
          <span>当前位置&nbsp;:&nbsp;</span>
          <router-link to="/" exact>&nbsp;首页&nbsp;>&nbsp;</router-link>
          <span>了解我们&nbsp;>&nbsp;</span>
          <em>{{this.showLabel}}</em>
          <!-- <router-link to="/understand" exact>了解我们</router-link> -->
        </div>
        <div class="center">
          <First :is="current"></First>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import HeaderTop from '@/components/header-top/header-top.vue'
import CompanyTitle from '@/components/company-title/company-title.vue'
import RouterList from '@/components/router-list/router-list.vue'
import Banner from '@/components/banner/banner.vue'
import Footer from '@/components/footer/footer.vue'
import First from '@/components/understand-comp/first.vue'
import Second from '@/components/understand-comp/second.vue'
import Thred from '@/components/understand-comp/thred.vue'
import Fouth from '@/components/understand-comp/fouth.vue'
import Fifth from '@/components/understand-comp/fifth.vue'
import Sixth from '@/components/understand-comp/sixth.vue'
import Seventh from '@/components/understand-comp/seventh.vue'
import Eighth from '@/components/understand-comp/eighth.vue'
export default {
  components: {
    HeaderTop,
    CompanyTitle,
    RouterList,
    Banner,
    Footer,
    First,
    Second,
    Thred,
    Fouth,
    Fifth,
    Sixth,
    Seventh,
    Eighth
  },
  data() {
    return {
      current:'First',
      showIndex:0,
      showLabel:'企业简介',
      companyList:[
        // {
        //   label:'了解我们',
        //   comp:'First'
        // },
        {
          label:'企业简介',
          comp:'Second'
        },
        {
          label:'业务范围',
          comp:'Thred'
        },
        {
          label:'内设机构',
          comp:'Fouth'
        },
        {
          label:'审查专家',
          comp:'Fifth'
        },
        {
          label:'企业荣誉',
          comp:'Sixth'
        },
        {
          label:'企业文化',
          comp:'Seventh'
        },
        {
          label:'位置标示',
          comp:'Eighth'
        }
      ]
    }
  },
  methods:{
    onChange(item,index){
      this.showIndex = index
      this.showLabel = item.label
      this.current = item.comp
      // console.log(this.showLabel)
    }
  }
}
</script>
<style lang="stylus" scoped>
.active
  background #3377FF
  color #ffffff !important 
.continer
  .content
    width 1200px
    margin 30px auto 85px
    display flex
    flex-wrap wrap 
    justify-content space-between
    .tab-list
      width 168px
      ul
        li
          height 52px
          line-height 52px
          padding 0 0 0 24px
          box-sizing border-box
          font-size 12px
          color #333333
          letter-spacing .5em
          box-shadow 0px 0px 10px 0px rgba(0, 0, 0, 0.05)
          &:hover
            color #3377FF
    .right-content
      width 1012px
      .navigation
        height 52px
        background:rgba(255,255,255,1)
        box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.05)
        margin-bottom 10px
        font-size 12px
        padding 18px 20px
        box-sizing border-box
        span,a 
          color #666
        em 
          color #3377FF
      .center
        // height 1200px
        min-height 520px
        width 100%
        background #f5f5f5
        box-shadow 0px 0px 10px 0px rgba(0, 0, 0, 0.05)
        padding 26px 32px
        box-sizing border-box
</style>
